// extracted by mini-css-extract-plugin
export var activeItem = "play-list-module--active-item--c4baa";
export var additionalSingleMovieHolder = "play-list-module--additional-single-movie-holder--4cdae";
export var bold = "play-list-module--bold--98dcf";
export var breakTime = "play-list-module--break-time--bc124";
export var btn = "play-list-module--btn--7c82b";
export var durationTime = "play-list-module--duration-time--0d12b";
export var emptyInfo = "play-list-module--empty-info--c8e4a";
export var gatsbyImageWrapper = "play-list-module--gatsby-image-wrapper--5ba0d";
export var icon = "play-list-module--icon--696dd";
export var labelName = "play-list-module--label-name--48460";
export var listItem = "play-list-module--list-item--c674b";
export var movieCounter = "play-list-module--movie-counter--a3083";
export var playIcon = "play-list-module--play-icon--e78b9";
export var playerItemInfo = "play-list-module--player-item-info--e85d4";
export var playlist = "play-list-module--playlist--1841c";
export var ratioClass = "play-list-module--ratio-class--c7062";
export var time = "play-list-module--time--e00ed";
export var title = "play-list-module--title--a0f61";
export var topWrapper = "play-list-module--top-wrapper--9fad5";
export var trainingTypeWrapper = "play-list-module--training-type-wrapper--674e9";
export var wrapper = "play-list-module--wrapper--9d5c6";